export const MINIMUM_REQUIREMENT_ENTITY_TYPE = {
  PRODUCT: 'product',
  MEMBER: 'member',
  ASSET: 'asset',
};
